/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { Acknowledgement } from '../components/Acknowledgement';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import React, { useEffect, useState } from 'react';
import { config } from '../config/success.config';
import { usePaymentId } from '../provider';

export const ContainerComm = (props: any) => {
  const { onNavigate } = props;
  const { message, paymentId } = usePaymentId();
  console.log('message + paymentId', message, '+', paymentId);
  useEffect(() => {
    const iframeUrl = window.location.href;
    console.log('URL inside the iframe2:', iframeUrl);
    const { message, paymentId } = usePaymentId();
    console.log('message + paymentId', message, '+', paymentId);
    // You can use the URL as needed within the iframe

    // For example, you might want to send the URL to the parent window
    window.parent.postMessage(iframeUrl, '*');
  }, []);

  return (
    <>
      <Acknowledgement {...config} message={message} paymentId={paymentId} />
    </>
  );
};

ContainerComm.defaultProps = {};
